import { baseAPIRequest } from 'utilities/http';

function authenticateUser (data) {

	return baseAPIRequest({ url: '/account/popups/authentication', data, params: { method: 'POST' } });

}

export default authenticateUser;
